import { render } from "./DetailMessage.vue?vue&type=template&id=194d3c23&scoped=true&ts=true"
import script from "./DetailMessage.vue?vue&type=script&lang=ts"
export * from "./DetailMessage.vue?vue&type=script&lang=ts"

import "./DetailMessage.vue?vue&type=style&index=0&id=194d3c23&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194d3c23"]])

export default __exports__